import { IconError404 } from "@tabler/icons-react";
import { Link } from "react-router-dom";

import { ROUTES } from "#shared/routes";
import { Center } from "#shared/view/components/Center";
import { Stack } from "#shared/view/components/Stack";
import { Button } from "#shared/view/designSystem/Button";

export const NoMatch = () => {
  return (
    <Center h="100vh" w="100vw">
      <Stack justify="center" align="center">
        <IconError404 />

        <p>Il semblerait qu’il n’y ait rien par ici.</p>

        <Link to={ROUTES.login}>
          <Button variant="outline">Cliquez ici pour retourner à la page principale</Button>
        </Link>
      </Stack>
    </Center>
  );
};
